import {forwardRef, ForwardRefExoticComponent, RefAttributes} from 'react';

import FormPieInputBase from './FormPieInputBase';
import {FormInputProps} from './types';
import FormPiePasswordInput from './FormPiePasswordInput';

type FormPieInputProps = FormInputProps & {isFocused?: boolean};

type TypeMap = Record<
  NonNullable<FormPieInputProps['type']> | 'default',
  ForwardRefExoticComponent<FormPieInputProps & RefAttributes<HTMLInputElement>>
>;

const typeMap: TypeMap = {
  text: forwardRef<HTMLInputElement, FormPieInputProps>((props, ref) => <FormPieInputBase ref={ref} {...props} />),
  password: forwardRef<HTMLInputElement, FormPieInputProps>((props, ref) => <FormPiePasswordInput ref={ref} {...props} />),
  default: forwardRef<HTMLInputElement, FormPieInputProps>((props, ref) => <FormPieInputBase ref={ref} {...props} />),
};

const FormPieInput = forwardRef<HTMLInputElement, FormPieInputProps>((props, ref) => {
  const Input = typeof props.type === 'string' && props.type in typeMap ?
    typeMap[props.type] :
    typeMap.default;

  return (
    <Input ref={ref} {...props} />
  );
});

export default FormPieInput;
